// Browser tab titles. The server writes the first page's <title> (src/server/meta.ts, for link previews);
// this keeps it right as you navigate inside the app. Pages with their own name (a game) call useDocumentTitle.
import { useEffect } from "react";
import { useLocation } from "react-router";

const SITE = "ExoWare";

const TITLES: [RegExp, string][] = [
  [/^\/$/, `${SITE} · In-house game software`],
  [/^\/games$/, "Games"],
  [/^\/pricing$/, "Pricing"],
  [/^\/status$/, "Status"],
  [/^\/changelog$/, "Changelog"],
  [/^\/login$/, "Sign in"],
  [/^\/register$/, "Create your account"],
  [/^\/forgot$/, "Forgot password"],
  [/^\/reset\//, "Reset password"],
  [/^\/verify-email\//, "Verify email"],
  [/^\/checkout/, "Checkout"],
  [/^\/home$/, "Home"],
  [/^\/licenses/, "Licenses"],
  [/^\/downloads/, "Downloads"],
  [/^\/guides/, "Guides"],
  [/^\/support/, "Support"],
  [/^\/account/, "Account"],
  [/^\/admin\/?$/, "Admin"],
  [/^\/admin\/([a-z-]+)/, "Admin"],
];

export const fullTitle = (t: string) => (t.startsWith(SITE) ? t : `${t} · ${SITE}`);

/** Sets the tab title from the current path. Mount once, above the routes. */
export function TitleSync() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/+$/, "") || "/";
    const hit = TITLES.find(([re]) => re.test(path));
    document.title = hit ? fullTitle(hit[1]) : SITE;
  }, [pathname]);
  return null;
}

/** For pages named by their data (e.g. a game). Does nothing until `title` is known. */
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => { if (title) document.title = fullTitle(title); }, [title]);
}
